import store from '@/store'
import { CLEAR, INIT, SET_LOADING_STATUS, SET_STATUS_MESSAGE, SET_TOTAL_COUNT, SPLICE } from './mutation-types'

const state = {
  metLocations: [],
  totalCount: 0,
  status: {
    loading: false,
    message: 'Loading'
  }
}

const getters = {
  getLoadingStatus: (state) => {
    return state.status.loading
  },
  getLoadingText: (state) => {
    return state.status.message
  },
  getAllGroups: (state) => {
    return state.metLocations
  },
  getTotalCount: (state) => {
    return state.totalCount
  }
}

const actions = {
  setLoadingStatus ({ commit }, { val }) {
    commit(SET_LOADING_STATUS, { val })
  },
  setStatusMessage ({ commit }, { message }) {
    commit(SET_STATUS_MESSAGE, { message })
  },
  async init ({ commit }, { newMetLocations, totalCount, isFullArraySize }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SET_TOTAL_COUNT, { val: totalCount })
      commit(INIT, { newMetLocations, totalCount: isFullArraySize ? totalCount : newMetLocations.length })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  // index is the current index
  async next ({ commit }, { newMetLocations, startIndex }) {
    commit(SET_LOADING_STATUS, { val: false })
    try {
      commit(SPLICE, { newMetLocations, startIndex })
    } catch (error) {
      store.dispatch('alert/error', error.message)
    }
  },
  clear ({ commit }) {
    commit(CLEAR)
  },
  setTotalCount ({ commit }, { val }) {
    commit(SET_TOTAL_COUNT, { val })
  }
}

const mutations = {
  [SET_LOADING_STATUS] (state, { val }) {
    state.status.loading = val
  },
  [SET_STATUS_MESSAGE] (state, { message }) {
    state.status.message = message
  },
  [INIT] (state, { newMetLocations, totalCount }) {
    if (totalCount === 0) return
    const objs = JSON.parse(JSON.stringify(newMetLocations))
    state.metLocations = new Array(totalCount)
    const mappedObjs = objs.map(obj => {
      obj.listContactsRoute = { name: 'metLocationContacts',
        params: { metLocationId: obj.id },
        query: { metLocationName: obj.name } }
      return obj
    })
    state.metLocations.splice(0, objs.length, ...mappedObjs)
  },
  [SPLICE] (state, { newMetLocations, startIndex }) {
    const objs = JSON.parse(JSON.stringify(newMetLocations))
    const mappedObjs = objs.map(obj => {
      obj.listContactsRoute = { name: 'metLocationContacts',
        params: { metLocationId: obj.id },
        query: { metLocationName: obj.name } }
      return obj
    })
    state.groups.splice(startIndex, objs.length, ...mappedObjs)
  },
  [SET_TOTAL_COUNT] (state, { val }) {
    state.totalCount = val
  },
  [CLEAR] (state) {
    state.metLocations = []
    state.status = {
      loading: false,
      message: 'Loading Met Locations. Please wait...'
    }
  }
}

export const metLocation = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
